
  import { defineComponent } from 'vue';
  import BulkDeleteButton from '@/ui/components/button/BulkDeleteButton.vue';
  import { InputField, TagField } from '@/ui/components/form';
  import { DateRangeField } from '@/ui/components/form/DateRangeField';

  export default defineComponent({
    name: 'FilterForm',
    components: {
      BulkDeleteButton,
      DateRangeField,
      InputField,
      TagField,
    },
    props: {
      selectedResources: Array,
      search: String,
      doneBy: Array,
      approvers: Array,
      updatedAtStart: String,
      updatedAtEnd: String,
      status: Array,
      type: Array,
      users: Array,
      statuses: Array,
      types: Array,
      updateFilter: Function,
    },
  });
